import React from "react";
// import { ReactComponent as Logo } from "../../../src/assets/images/logo.png";
import Logo from "../../../src/assets/images/logo.png";
import { useNavigate } from "react-router-dom";
import callIcon from "../../../src/assets/images/8.svg"
import mailIcon from "../../../src/assets/images/9.svg"
import addressIcon from "../../../src/assets/images/7.svg"
export const Footer = () => {
    const navigate = useNavigate();
    return (
        <div style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            background: "#f7941d",
            width: "100%",
            minHeight: 200,
            height: "auto",
            gap: 30,
            color: "#151515",
            fontSize: window.innerWidth < 600 ? 16 : window.innerWidth < 1000 ? 18 : 20,
            fontWeight: 400,
            marginTop: 60,
            padding: window.innerWidth < 1000 ? "20px 5px" : "0",
            boxSizing: "border-box"
        }}>
            <div style={{
                fontSize: 18,
                width: "98%",
                display: "flex",
                flexWrap: "wrap",
                justifyContent: window.innerWidth < 1000 ? "flex-start" : "space-between",
                alignItems: window.innerWidth < 1000 ? "flex-start" : "center",
                flexDirection: window.innerWidth > 1000 ? "row" : "column",
                marginTop: 30,
                marginLeft: window.innerWidth > 1000 ? 0 : 0,
                gap: window.innerWidth < 1000 ? 20 : 0,
            }}>
                <div style={{ display: "flex", justifyContent: "space-between", gap: window.innerWidth > 1000 ? 30 : 10, flexDirection: window.innerWidth > 1000 ? "row" : "column" }}>
                    <div style={{ textAlign: "left", marginLeft: 30 }}>
                        <div
                            style={{
                                fontSize: "20px",
                                textDecorationLine: "underline",
                                textDecorationThickness: "1px", // thinner underline
                                textUnderlineOffset: "3px",     // optional: adjust vertical space
                            }}
                        >
                            Quick links
                        </div>
                        <div style={{ cursor: "pointer" }} onClick={() => navigate("/")}>Home</div>
                        <div style={{ cursor: "pointer" }} onClick={() => navigate("/why_thy")}>Why THY?</div>
                        <div style={{ cursor: "pointer" }} onClick={() => navigate("/services")}>Services</div>
                        <div style={{ cursor: "pointer" }} onClick={() => navigate("/products")}>Products</div>
                        <div style={{ cursor: "pointer" }} onClick={() => navigate("/contact_us")}>
                            Contact us
                        </div>
                    </div>

                </div>
                <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", width: window.innerWidth > 1000 ? "40%" : "80%", textAlign: "left", marginTop: window.innerWidth < 1000 ? 20 : 0 }}>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 10 }}>
                        <div><img style={{ width: 20, height: 20 }} src={callIcon}></img></div>
                        <div>+91 8925971781</div>

                    </div>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 10 }}>
                        <div><img style={{ width: 20, height: 20 }} src={callIcon}></img></div>
                        <div>+91 8925971782</div>

                    </div>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 10 }}>
                        <div><img style={{ width: 20, height: 20 }} src={mailIcon}></img></div>
                        <div>info@thydesigners.com</div>
                    </div>
                    <div style={{ display: "flex", justifyContent: "center", gap: 10 }}>
                        <div style={{ marginTop: 3 }}><img style={{ width: 20, height: 20 }} src={addressIcon}></img></div>
                        <div>90/24, Mangapathy St, Adikesavarpuram, Chintadripet, Chennai, Tamil Nadu 600002</div>
                    </div>
                </div>
            </div>
            <div style={{ marginTop: 10, borderTop: "1px solid white", width: "100%", padding: 10, fontSize: 14 }}>
                Developed by <a href="https://digital.honesti.in" style={{ color: "#fff" }}>Honesti Digital</a>
            </div>
        </div>
    )
}